import {
  createGlobalStyle,
  css,
  default as styled,
  ThemeProvider
} from "styled-components";

export { css, createGlobalStyle, ThemeProvider };
export default styled;



// WEBPACK FOOTER //
// ./src/themes/index.tsx